import React, { useState, useEffect } from 'react';
import { Card, Col, Input, Row, Upload } from 'antd';
import { DeleteFilled, InboxOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { InputField, TextAreaField } from 'components/FormFields';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StyledContainer = styled.div`
  .row {
    margin-bottom: 16px;
  }

  .label {
    text-align: left;
    padding-right: 8px;
    flex: 1 0 30px;
  }

  .input,
  .select,
  .textarea,
  .datepicker {
    flex: 2;
  }

  .select .ant-select {
    width: 100%;
  }

  .textarea .ant-input {
    width: 100%;
    min-height: 120px;
  }

  .datepicker .ant-picker {
    width: 100%;
  }

  .status .ant-select {
    width: 100%;
    min-height: 110px;
    display: flex;
    align-items: center;
  }
`;

const CourseContent = ({ control, callBack, getValues }) => {
  const { id } = useParams();
  const [fileList, setFileList] = useState([]);
  const { t } = useTranslation(['trainningManagement']);

  useEffect(() => {
    const learningMaterial = getValues('learningMaterial');
    if (learningMaterial && learningMaterial.length > 0) {
      const files = learningMaterial.map((material, index) => {
        return {
          uid: index,
          name: material?.fileName,
          status: 'done',
          url: material?.fileUrl,
        };
      });
      setFileList(files);
    }
  }, [getValues('learningMaterial')]);

  const handleUpload = (info) => {
    callBack(info.fileList);
    setFileList(
      info.fileList.map((file) => ({
        uid: file.uid,
        name: file.name,
        status: file.status,
        url: file.url || URL.createObjectURL(file.originFileObj),
      })),
    );
  };

  const handleRemove = (file) => {
    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(newFileList);
    callBack(newFileList);
  };

  return (
    <StyledContainer>
      <Card
        title={t('course_management.course_content')}
        bordered={false}
        headStyle={{
          fontSize: 24,
          fontWeight: 500,
        }}
      >
        <Row gutter={[100, 16]}>
          <Col span={14}>
            <Row className="row" align="middle">
              <Col className="label">{t('course_management.lesson_name')}</Col>
              <Col className="input">
                <InputField control={control} name="contentLessonName" />
              </Col>
            </Row>
            <Row className="row" align="middle">
              <Col className="label">{t('course_management.learning_material')}</Col>
              <Col className="select">
                {fileList.length > 0 ? (
                  <div style={{ marginTop: 16 }}>
                    {fileList.map((file) => (
                      <div
                        key={file.uid}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: 8,
                        }}
                      >
                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                          {file.name}
                        </a>
                        {!id && <DeleteFilled onClick={() => handleRemove(file)} />}
                      </div>
                    ))}
                  </div>
                ) : (
                  <Upload.Dragger
                    fileList={fileList}
                    onChange={handleUpload}
                    onRemove={handleRemove}
                    showUploadList={false}
                    multiple={false}
                    accept=".pdf"
                    disabled={id}
                  >
                    <div>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        {t('course_management.click_or_drag_file_to_this_area_to_upload')}
                      </p>
                    </div>
                  </Upload.Dragger>
                )}
              </Col>
            </Row>
            <Row className="row" align="middle">
              <Col className="label">{t('course_management.description')}</Col>
              <Col className="textarea">
                <TextAreaField
                  control={control}
                  name="contentDescription"
                  autoSize={{ minRows: 4, maxRows: 6 }}
                />
              </Col>
            </Row>
            <Row className="row" align="middle">
              <Col className="label">{t('course_management.learning_url')}</Col>
              <Col className="input">
                <InputField control={control} name="contentLearningUrl" />
              </Col>
            </Row>
          </Col>
          <Col span={12}></Col>
        </Row>
      </Card>
    </StyledContainer>
  );
};

export default CourseContent;
